/* eslint dot-notation: 0 */
import React, { Component, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Progress from 'vendor/spectacle/progress';
import ButtonBar from './buttonBar';
import Scores from './scores';
import Fun from './fun';
import FunVideoOverlay from './fun/funVideoOverlay';
import Overview from './overview';
import Exit from './exit';
import ImageLogo from '../../images/logo_ppa.svg';
import DrawerLogoFile_en from '../../images/drawer-logo-full-logo_ppa.png';
import DrawerLogoFile_fr_CA from '../../images/drawer-logo-full-logo_ppa.fr_CA.png';
import './hud.scss';
import { i18nData } from 'helpers/i18n'

const DrawerLogo = i18nData({
  en: DrawerLogoFile_en,
  fr_CA: DrawerLogoFile_fr_CA
})

export default class HeadsUpDisplay extends Component {

  static propTypes = {
    slide: PropTypes.number.isRequired,
    displayHUD: PropTypes.bool.isRequired,
    displayHUDToggle: PropTypes.bool.isRequired,
    displayArrows: PropTypes.bool.isRequired,
    displayExit: PropTypes.bool.isRequired,
    TOC: PropTypes.array.isRequired,
    currentSlide: PropTypes.number.isRequired,
    progressType: PropTypes.string.isRequired,
    prevSlide: PropTypes.func.isRequired,
    nextSlide: PropTypes.func.isRequired,
    mode: PropTypes.string,
    deckHeight: PropTypes.number
  };

  static contextTypes = {
    session: PropTypes.object.isRequired,
    setCurrentSlide: PropTypes.func.isRequired,
    setLastSlide: PropTypes.func.isRequired,
    setActiveSession: PropTypes.func.isRequired,
    hideHUD: PropTypes.func.isRequired,
    staff: PropTypes.bool,
    profile: PropTypes.object.isRequired,
    registerHUDRef: PropTypes.func.isRequired,
    i18n: PropTypes.func.isRequired
  };

  componentDidMount () {
    this.hudTimerCount = 0;
    this.interval = setInterval(::this.hudTimerCheck, 1000);
    this.context.registerHUDRef('Menu', this.refs['deck-hud-toggle']);
    this.context.registerHUDRef('Next Arrow', this.refs['nextArrow']);
  }

  componentWillUnmount () {
    clearInterval(this.interval);
  }

  hudTimerCheck () {
    // If the HUD is open for 10 seconds without being in a 'mode',
    // then close it

    const { displayHUD, mode } = this.props;
    const { hideHUD, profile } = this.context;
    if (displayHUD && !mode && profile.onboarding) {
      this.hudTimerCount++;
      if (this.hudTimerCount > 10) {
        hideHUD();
        this.hudTimerCount = 0;
      }
    } else {
      this.hudTimerCount = 0;
    }
  }

  clickHUDDrawer (evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.nativeEvent.stopPropagation();
    }
  }

  jumpTo () {
    const { setCurrentSlide, setLastSlide } = this.context;
    const slide = this.refs.jumpTo.value;
    setLastSlide(slide);
    setCurrentSlide(slide);
  }

  exitSession () {
    const { setActiveSession } = this.context;
    setActiveSession('none');
  }

  render () {
    const { session: { currentLevel }, staff, i18n: _ } = this.context;
    const {
      slide,
      displayHUD,
      displayHUDToggle,
      displayExit,
      TOC,
      currentSlide,
      progressType,
      prevSlide,
      nextSlide,
      mode,
      deckHeight
    } = this.props;
    const currentSlideId = TOC[slide].id;
    let yOffset = 122;
    if (window.screen.width >= 1600) {
      yOffset = 142;
    }
    const deckHeightWithoutProgressBar = deckHeight - 22;
    let yPosition = `${-deckHeightWithoutProgressBar}px`;
    if (displayHUD && deckHeight) {
      yPosition = mode ? 0 : `${yOffset - deckHeight}px`;
    }
    let funVideoNumber = null;
    const match = mode ? mode.match(/^extras\/(.*)$/) : null;
    if (match) {
      funVideoNumber = Number(match[1]);
    }

    const styles = {
      hudDrawer: {
        transform: `translateY(${yPosition})`,
        WebkitTransform: `translateY(${yPosition})`,
        transition: 'transform 0.5s cubic-bezier(0, 0, .58, 1)',
        WebkitTransition: '-webkit-transform 0.5s cubic-bezier(0, 0, .58, 1)',
        height: deckHeight
      },
      hudPrevButton: {
        opacity: slide > 0 ? 1 : 0
      },
      hudNextButton: {
        opacity: slide < TOC.length - 1 ? 1 : 0
      }
    };

    return (
      <div
          className="deck-control-glass">
        <a
            className={`deck-hud-toggle ${(displayHUD && mode) ? 'on' : ''}`}
            href="#"
            style={{display: displayHUDToggle ? 'flex' : 'none'}}
            ref="deck-hud-toggle">
          <svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 56.6"><path className="logo-center" d="M48.2 27.5c0-1.7-.8-3.2-2.2-4.3.6-1.6.6-3.3-.3-4.8-.8-1.5-2.3-2.4-4-2.6-.3-1.7-1.2-3.2-2.6-4-1.5-.8-3.2-.9-4.8-.3-1.1-1.3-2.6-2.2-4.3-2.2s-3.2.8-4.3 2.2c-1.6-.6-3.3-.6-4.8.3-1.5.8-2.4 2.3-2.6 4-1.7.3-3.2 1.2-4 2.6-.8 1.5-.9 3.2-.3 4.8-1.3 1.1-2.2 2.6-2.2 4.3s.8 3.2 2.2 4.3c-.6 1.6-.6 3.3.3 4.8.8 1.4 2.3 2.4 4 2.6.3 1.7 1.2 3.2 2.6 4 1.5.8 3.2.9 4.8.3 1.1 1.3 2.6 2.2 4.3 2.2s3.2-.8 4.3-2.2c1.6.6 3.3.6 4.8-.3 1.5-.8 2.4-2.3 2.6-4 1.7-.3 3.2-1.2 4-2.6.8-1.5.9-3.2.3-4.8 1.3-1.1 2.2-2.6 2.2-4.3zm-8 10.2c-1.3 0-2.9-.4-4.4-1.2-.3-2.2-1.1-4-2.2-5.4 1.3 1.1 3.1 1.9 5.4 2.2.8 1.5 1.2 3.1 1.2 4.4zm-9.6.4c.8-2.1 1.1-4.1.8-5.7.6 1.6 1.8 3.2 3.6 4.6 0 1.8-.5 3.3-1.1 4.4-1.3-.6-2.4-1.8-3.3-3.3zm-4.3 3.3c-.7-1.2-1.1-2.7-1.1-4.4 1.8-1.4 3-3 3.6-4.6-.3 1.7 0 3.7.8 5.7-1 1.5-2.1 2.7-3.3 3.3zm-6.5-3.7c0-1.3.4-2.9 1.2-4.4 2.2-.3 4-1.1 5.4-2.2-1.1 1.3-1.9 3.1-2.2 5.4-1.5.8-3 1.2-4.4 1.2zm0-20.4c1.3 0 2.9.4 4.4 1.2.3 2.2 1.1 4 2.2 5.4-1.3-1.1-3.1-1.9-5.4-2.2-.8-1.5-1.2-3-1.2-4.4zm9.7-.4c-.8 2.1-1.1 4.1-.8 5.7-.6-1.6-1.8-3.2-3.6-4.6 0-1.8.5-3.3 1.1-4.4 1.3.7 2.4 1.8 3.3 3.3zm-4.4 9.3c-1.7-.3-3.7 0-5.7.8-1.5-.9-2.6-2-3.3-3.2 1.2-.7 2.7-1.1 4.4-1.1 1.4 1.7 3 2.9 4.6 3.5zm0 2.6c-1.6.6-3.2 1.8-4.6 3.6-1.8 0-3.3-.5-4.4-1.1.7-1.2 1.8-2.3 3.3-3.2 2.1.8 4 1 5.7.7zm3.8 2.9c-.6 1.5-2 3-3.7 4.2.1-2.1.8-4 1.8-5.3-1.3 1-3.2 1.7-5.3 1.8 1.2-1.7 2.7-3.1 4.2-3.7-1.6.2-3.6-.2-5.5-1.1 1.9-.9 3.9-1.3 5.5-1.1-1.5-.6-3-2-4.2-3.7 2.1.1 4 .8 5.3 1.8-1-1.3-1.7-3.2-1.8-5.3 1.7 1.2 3.1 2.7 3.7 4.2-.2-1.6.2-3.6 1.1-5.5.9 1.9 1.3 3.9 1.1 5.5.6-1.5 2-3 3.7-4.2-.1 2.1-.8 4-1.8 5.3 1.3-1 3.2-1.7 5.3-1.8-1.2 1.7-2.7 3.1-4.2 3.7 1.6-.2 3.6.2 5.5 1.1-1.9.9-3.9 1.3-5.5 1.1 1.5.6 3 2 4.2 3.7-2.1-.1-4-.8-5.3-1.8 1 1.3 1.7 3.2 1.8 5.3-1.7-1.2-3.1-2.7-3.7-4.2.2 1.6-.2 3.6-1.1 5.5-.9-1.9-1.3-3.9-1.1-5.5zm4.9-18.1c.7 1.2 1.1 2.7 1.1 4.4-1.8 1.4-3 3-3.6 4.6.3-1.7 0-3.7-.8-5.7 1-1.5 2.1-2.6 3.3-3.3zm6.4 3.7c0 1.3-.4 2.9-1.2 4.4-2.2.3-4 1.1-5.4 2.2 1.1-1.3 1.9-3.1 2.2-5.4 1.5-.8 3.1-1.2 4.4-1.2zm-5.3 11.5c1.7.3 3.7 0 5.7-.8 1.5.9 2.6 2 3.3 3.2-1.2.7-2.7 1.1-4.4 1.1-1.4-1.7-3-2.9-4.6-3.5zm0-2.6c1.6-.6 3.2-1.8 4.6-3.6 1.8 0 3.3.5 4.4 1.1-.7 1.2-1.8 2.3-3.3 3.2-2-.8-4-1-5.7-.7zm9.3-6.9c.5.9.6 1.9.4 3-1-.5-2.1-.7-3.4-.7h-.9c.2-.3.3-.5.5-.8.6-1.1.9-2.2 1-3.3 1 .3 1.9.9 2.4 1.8zm-6-6c.9.5 1.5 1.3 1.8 2.4-1.1.1-2.2.4-3.3 1-.3.2-.5.3-.8.5v-.9c0-1.2-.3-2.4-.7-3.4 1.1-.2 2.1-.1 3 .4zM30 11.2c1 0 2 .4 2.8 1.2-.9.6-1.7 1.5-2.3 2.5-.2.3-.3.6-.4.8-.1-.3-.3-.6-.4-.8-.6-1.1-1.4-1.9-2.3-2.5.7-.8 1.6-1.2 2.6-1.2zm-8.2 2.1c.9-.5 1.9-.6 3-.4-.5 1-.7 2.1-.7 3.4v.9c-.3-.2-.5-.3-.8-.5-1.1-.6-2.2-.9-3.3-1 .4-1 1-1.9 1.8-2.4zm-5.9 6c.5-.9 1.3-1.5 2.4-1.8.1 1.1.4 2.2 1 3.3.2.3.3.5.5.8h-.9c-1.2 0-2.4.3-3.4.7-.3-1-.1-2.1.4-3zm-2.2 8.2c0-1 .4-2 1.2-2.8.6.9 1.5 1.7 2.5 2.3.3.2.6.3.8.4-.3.1-.6.3-.8.4-1.1.6-1.9 1.4-2.5 2.3-.8-.6-1.2-1.6-1.2-2.6zm2.2 8.2c-.5-.9-.6-1.9-.4-3 1 .5 2.1.7 3.4.7h.9c-.2.3-.3.5-.5.8-.6 1.1-.9 2.2-1 3.3-1.1-.3-1.9-.9-2.4-1.8zm5.9 6c-.9-.5-1.5-1.3-1.8-2.4 1.1-.1 2.2-.4 3.3-1 .3-.2.5-.3.8-.5v.9c0 1.2.3 2.4.7 3.4-1 .2-2.1.1-3-.4zm8.2 2.2c-1 0-2-.4-2.8-1.2.9-.6 1.7-1.5 2.3-2.5.2-.3.3-.6.4-.8.1.3.3.6.4.8.6 1.1 1.4 1.9 2.3 2.5-.6.7-1.5 1.2-2.6 1.2zm8.2-2.2c-.9.5-1.9.6-3 .4.5-1 .7-2.1.7-3.4v-.9c.3.2.5.3.8.5 1.1.6 2.2.9 3.3 1-.3 1-.9 1.9-1.8 2.4zm6-6c-.5.9-1.3 1.5-2.4 1.8-.1-1.1-.4-2.2-1-3.3-.2-.3-.3-.5-.5-.8h.9c1.2 0 2.4-.3 3.4-.7.2 1.1.1 2.1-.4 3zm1-5.4c-.6-.9-1.5-1.7-2.5-2.3-.3-.2-.6-.3-.8-.4.3-.1.6-.3.8-.4 1.1-.6 1.9-1.4 2.5-2.3.8.8 1.2 1.7 1.2 2.8 0 .8-.4 1.8-1.2 2.6z"/><path className="logo-surround" d="M58.2 34.2c1.4-.7 1.8-2.6 1.8-2.6s-2.1-.2-3.4.8c-.4.3-.8.9-1.1 1.4.2-1.1.4-2.1.4-3.2.5-.1 1.6-.4 2.8-1.3 1.2-1 1.3-2.9 1.3-2.9s-2.1.1-3.2 1.3c-.3.4-.6 1-.8 1.6 0-1.2 0-2.3-.1-3.4.5-.2 1.5-.6 2.4-1.7 1-1.1.8-3 .8-3s-2 .5-2.8 1.8c-.3.4-.4 1.1-.5 1.7-.2-1.2-.4-2.3-.7-3.4.4-.2 1.4-.9 2.1-2.1.8-1.3.2-3 .2-3s-1.8.8-2.4 2.2c-.2.5-.2 1.3-.2 1.9-.4-1.2-.9-2.3-1.4-3.4.3-.3 1.2-1 1.7-2.4.5-1.3-.3-2.9-.3-2.9s-1.6 1.1-1.9 2.6c-.1.6 0 1.4.2 2-.6-1.2-1.3-2.3-2-3.3.3-.3 1-1.2 1.2-2.6s-.8-2.8-.8-2.8S50 9 50 10.5c0 .6.2 1.3.5 1.9-.8-1-1.7-2-2.5-2.8.2-.4.7-1.3.8-2.7 0-1.4-1.2-2.5-1.2-2.5s-1.1 1.5-.9 3c.1.6.5 1.3.8 1.8-.3-.3-.6-.5-.9-.8-.7-.6-1.4-1.1-2.1-1.5.1-.3.5-1.4.3-2.8-.2-1.3-1.6-2.3-1.6-2.3s-.8 1.7-.4 3c.2.6.9 1.4 1.3 1.8-1.3-.8-2.5-1.4-3.5-1.9.1-.3.3-1.4-.2-2.8C39.8.6 38.3 0 38.3 0s-.5 1.8.1 3c.3.6 1.2 1.2 1.6 1.6-.7-.3-1.3-.5-1.9-.7-.2-.2-.9-1.1-1.9-1.3-.8-.1-2.1.4-2.1.4s.6.8 1.9 1.3c.8.3 1.8-.1 2-.2.6.2 1.5.5 2.4 1-.5-.1-1.6-.2-2.3 0C36.9 5.4 36 7 36 7s1.5.6 2.7 0c1.3-.6 1.9-1.6 2.1-1.9 1 .5 2.2 1.1 3.4 2-.6-.2-1.5-.5-2.1-.4-1.4.2-2.5 1.7-2.5 1.7s1.4.9 2.7.5c1.3-.4 2.1-1.2 2.4-1.5.5.4 1.1.8 1.7 1.3.5.4 1 .8 1.5 1.3-.5-.3-1.4-.7-2.1-.7-1.4 0-2.9 1.2-2.9 1.2s1.3 1.1 2.7.9c1.4-.2 2.4-.8 2.6-1.1.9.9 1.7 1.9 2.5 3-.5-.4-1.2-.9-1.8-1-1.4-.3-3.1.7-3.1.7s1.1 1.3 2.5 1.4c1.4.1 2.4-.4 2.8-.6.7 1 1.3 2.1 1.9 3.2-.4-.5-1-1-1.6-1.2-1.4-.6-3.2.2-3.2.2s.9 1.6 2.3 1.9c1.3.3 2.4.1 2.9-.1.5 1.1.9 2.3 1.3 3.5-.3-.5-.8-1.2-1.3-1.5-1.3-.8-3.3-.4-3.3-.4s.6 1.7 1.9 2.3c1.3.5 2.4.5 2.9.4.3 1.2.5 2.4.7 3.7-.3-.6-.6-1.4-1.1-1.8-1.2-1-3.2-1-3.2-1s.3 1.8 1.6 2.6c1.2.8 2.4.9 2.8 1 .1 1.2.1 2.4 0 3.6-.1-.6-.4-1.4-.8-1.8-1-1.2-3.1-1.6-3.1-1.6s0 1.9 1.1 2.9 2.1 1.3 2.6 1.4c-.1 1.2-.3 2.3-.6 3.4 0-.6-.1-1.4-.4-2-.8-1.4-2.8-2.1-2.8-2.1s-.4 1.9.6 3.1c.9 1.1 1.9 1.7 2.4 1.9-.3 1.1-.7 2.1-1.2 3.1.1-.6.1-1.4-.1-1.9-.7-1.6-2.6-2.6-2.6-2.6s-.7 1.8 0 3.3c.6 1.3 1.6 2 2 2.3-.5 1-1 1.9-1.6 2.8.2-.6.3-1.3.2-1.9-.2-1.7-2-3-2-3s-1 1.7-.6 3.3c.4 1.4 1.2 2.3 1.6 2.7-.7.9-1.4 1.8-2.1 2.5.3-.6.6-1.3.6-1.9 0-1.7-1.5-3.4-1.5-3.4s-1.3 1.5-1.1 3.2c.2 1.5.8 2.5 1.2 3-.8.8-1.7 1.5-2.6 2.1.4-.6.8-1.3 1-1.9.4-1.7-.9-3.7-.9-3.7s-1.6 1.3-1.7 3c-.1 1.5.4 2.7.6 3.2-.3.2-.7.4-1 .6-.6.4-1.2.7-1.8.9.5-.5 1-1.1 1.2-1.6.7-1.7-.2-3.9-.2-3.9s-1.9 1-2.2 2.7c-.3 1.5-.1 2.7 0 3.3-1.1.5-2 .8-2.9 1.1.6-.4 1.2-.9 1.5-1.4 1-1.6.5-3.9.5-3.9s-2.1.7-2.7 2.4c-.6 1.4-.6 2.6-.6 3.3-1.8.4-3.8.6-5.8.6-1.9 0-3.8-.2-5.6-.6 0-.6 0-1.9-.6-3.3-.7-1.6-2.7-2.4-2.7-2.4s-.5 2.4.5 3.9c.3.5.9 1 1.5 1.4-.9-.3-1.9-.6-2.9-1.1.2-.6.4-1.8 0-3.3-.4-1.7-2.2-2.7-2.2-2.7s-.9 2.2-.2 3.9c.2.6.7 1.1 1.2 1.6l-1.8-.9-1-.6c.3-.6.7-1.7.6-3.2-.1-1.7-1.7-3-1.7-3s-1.2 2-.9 3.7c.1.6.6 1.3 1 1.9-.9-.6-1.7-1.3-2.6-2.1.3-.5 1-1.5 1.2-3 .2-1.7-1.1-3.2-1.1-3.2S11 42.3 11 44c0 .6.3 1.3.6 1.9-.7-.8-1.4-1.6-2.1-2.5.4-.4 1.2-1.3 1.6-2.7.5-1.6-.6-3.3-.6-3.3s-1.8 1.4-2 3c-.1.6 0 1.2.2 1.9-.6-.9-1.1-1.8-1.6-2.8.5-.3 1.4-1.1 2-2.3.7-1.4 0-3.3 0-3.3s-1.9 1-2.4 2.6c-.2.6-.2 1.3-.1 1.9-.5-1-.8-2-1.2-3.1.5-.2 1.5-.8 2.4-1.9 1-1.2.6-3.1.6-3.1s-2 .7-2.8 2.1c-.3.5-.4 1.3-.4 2-.3-1.1-.5-2.2-.6-3.4.5-.1 1.6-.5 2.6-1.4 1.1-1 1.1-2.9 1.1-2.9s-2 .3-3 1.6c-.4.5-.6 1.2-.8 1.8-.1-1.2-.1-2.4 0-3.6.5 0 1.6-.2 2.8-1 1.3-.7 1.6-2.5 1.6-2.5s-2.1-.1-3.2 1c-.5.4-.9 1.2-1.1 1.8.1-1.3.4-2.5.7-3.7.5 0 1.6.1 2.9-.4 1.4-.6 1.9-2.3 1.9-2.3s-2-.4-3.3.4c-.5.3-1 1-1.3 1.5.4-1.2.8-2.4 1.3-3.5.5.1 1.5.4 2.9.1C11.1 17.6 12 16 12 16s-1.8-.7-3.2-.2c-.7.2-1.2.7-1.7 1.2.6-1.2 1.2-2.2 1.9-3.2.4.2 1.4.6 2.8.6 1.4-.1 2.5-1.4 2.5-1.4s-1.7-1-3.1-.7c-.6.1-1.4.6-1.8 1 .8-1.1 1.6-2.1 2.5-3 .3.2 1.2.9 2.6 1.1 1.4.2 2.7-.9 2.7-.9s-1.4-1.3-2.9-1.2c-.7 0-1.6.4-2.1.7.5-.5 1-.9 1.5-1.3.6-.5 1.1-.9 1.7-1.3.3.3 1.1 1.1 2.4 1.5 1.3.4 2.7-.5 2.7-.5S19.3 6.9 18 6.7c-.6-.1-1.6.2-2.1.4 1.2-.8 2.4-1.5 3.4-2 .2.3.8 1.2 2.1 1.9 1.2.6 2.7 0 2.7 0s-.9-1.6-2.2-2c-.7-.2-1.8-.1-2.3 0 .9-.4 1.7-.7 2.4-1 .3.1 1.2.5 2 .2 1.2-.4 1.9-1.3 1.9-1.3s-1.3-.5-2.1-.4c-1 .2-1.8 1.1-1.9 1.3-.5.2-1.2.4-1.9.7.5-.3 1.3-1 1.6-1.6.6-1.2.2-3 .2-3s-1.5.6-1.9 1.9c-.5 1.4-.2 2.5-.2 2.8-1.1.5-2.2 1.1-3.5 1.9.4-.4 1.1-1.2 1.3-1.8.4-1.3-.4-3-.4-3s-1.6.9-1.8 2.3c-.2 1.4.2 2.5.3 2.8l-2.1 1.5c-.3.2-.6.5-.9.8.3-.5.7-1.2.8-1.8.2-1.4-.9-3-.9-3s-1.2 1.2-1.2 2.5c0 1.4.6 2.4.8 2.7-.9.8-1.7 1.8-2.5 2.8.2-.5.4-1.3.4-1.9C10 9 8.6 7.6 8.6 7.6S7.5 9 7.8 10.4c.3 1.4 1 2.3 1.2 2.6-.7 1-1.4 2.1-2 3.3.1-.6.3-1.4.2-2-.3-1.5-1.9-2.6-1.9-2.6s-.8 1.6-.3 2.9 1.4 2.1 1.7 2.4c-.5 1.1-1 2.2-1.4 3.4 0-.6 0-1.4-.2-1.9-.6-1.4-2.4-2.2-2.4-2.2s-.5 1.7.2 3c.7 1.2 1.7 1.8 2.1 2.1-.3 1.1-.6 2.3-.7 3.4-.2-.7-.3-1.3-.6-1.8-.8-1.3-2.8-1.8-2.8-1.8s-.2 1.8.8 3c.9 1.1 1.9 1.5 2.4 1.7-.2 1.1-.2 2.2-.1 3.4-.2-.6-.5-1.2-.8-1.6C2.1 26.6 0 26.4 0 26.4s.1 1.9 1.3 2.8c1.1.9 2.3 1.2 2.8 1.3.1 1.1.2 2.2.4 3.2-.3-.5-.7-1.1-1.1-1.4-1.3-1-3.4-.8-3.4-.8s.4 1.9 1.8 2.6c1.3.7 2.4.8 3 .8.3 1.1.6 2.1 1 3.1-.4-.5-.9-1-1.3-1.2C3 36 .9 36.6.9 36.6s.8 1.8 2.3 2.3c1.4.5 2.6.4 3.1.3.5 1 1 2 1.6 2.9-.5-.4-1.1-.8-1.6-1-1.6-.5-3.6.5-3.6.5s1.1 1.7 2.7 1.9c1.5.2 2.7-.1 3.2-.3.6.9 1.2 1.7 1.9 2.5-.5-.3-1.1-.6-1.6-.6-1.7-.2-3.6 1.1-3.6 1.1s1.4 1.5 3.1 1.5c1.5 0 2.6-.5 3.1-.8.7.7 1.5 1.4 2.2 2-.5-.2-1.1-.3-1.6-.3-1.8.1-3.4 1.7-3.4 1.7s1.7 1.2 3.3.9c1.5-.3 2.5-1 3-1.4.5.4 1.1.7 1.6 1l1 .6c-.6-.1-1.2-.1-1.7 0-1.8.4-3.1 2.3-3.1 2.3s1.9 1 3.5.3c1.4-.6 2.3-1.4 2.7-1.9 1 .5 1.9.8 2.8 1.1-.6 0-1.2.1-1.7.3-1.7.7-2.7 2.9-2.7 2.9s2.1.6 3.6-.3c1.3-.8 2.1-1.8 2.4-2.4 2.1.5 4.3.8 6.6.8s4.6-.3 6.6-.8c.3.6 1.1 1.6 2.4 2.4 1.5.9 3.6.3 3.6.3s-1-2.2-2.7-2.9c-.5-.2-1.1-.3-1.7-.3.9-.3 1.8-.6 2.8-1.1.4.5 1.3 1.3 2.7 1.9 1.6.6 3.5-.3 3.5-.3s-1.3-2-3.1-2.3c-.5-.1-1.1 0-1.7 0 .3-.2.7-.4 1-.6.5-.3 1.1-.6 1.6-1 .5.4 1.5 1.1 3 1.4 1.7.3 3.3-.9 3.3-.9s-1.6-1.7-3.4-1.7c-.5 0-1.1.1-1.6.3.7-.6 1.5-1.3 2.2-2 .5.3 1.6.8 3.1.8 1.7 0 3.1-1.5 3.1-1.5s-1.8-1.3-3.6-1.1c-.5.1-1.1.3-1.6.6.7-.8 1.3-1.6 1.9-2.5.5.2 1.7.5 3.2.3 1.6-.2 2.7-1.9 2.7-1.9s-2-1-3.6-.5c-.5.2-1.1.6-1.6 1 .6-.9 1.1-1.9 1.6-2.9.5.1 1.7.2 3.1-.3 1.5-.5 2.3-2.3 2.3-2.3s-2.1-.6-3.6.2c-.5.2-.9.7-1.3 1.2.4-1 .7-2 1-3.1.6.1 1.7 0 3-.7z"/></svg>
          <span className="deck-hud-toggle-label">{_('Menu')}</span>
        </a>
        { !!displayExit &&
          <button className="btn btn-sm btn-default deck-hud-exit" onClick={::this.exitSession}>
            <span className="ppa-icon-exit"></span> {_('Exit')}
          </button>
        }
        <div
            className={`deck-hud-drawer ${(displayHUD && mode) ? 'on' : ''}`}
            ref="hudDrawer"
            style={styles.hudDrawer}
            onClick={::this.clickHUDDrawer}>
          <div className="deck-hud-drawer-logo">
            <img src={_(DrawerLogo)}/>
          </div>
          <div
              className="deck-hud-panel">
            <div className="deck-hud-logo">
              <img src={ImageLogo}/>
            </div>
            <div
                className="deck-hud-content">
                <ReactCSSTransitionGroup
                    className="deck-hud-content-transition-group"
                    transitionName="hud-mode-switch"
                    transitionEnterTimeout={500}
                    transitionLeaveTimeout={300}>
                {mode === 'scores' ? <Scores key="scores" /> : null}
                { mode && (mode.replace(/\/.*$/, '') === 'extras')
                ? <Fun key="extras" />
                : null
                }
                {mode === 'modules' ? <Overview key="modules" /> : null}
                {mode === 'exit' ? <Exit key="exit" /> : null}
                </ReactCSSTransitionGroup>
            </div>
            <ButtonBar />
            {staff &&
              <div className="deck-hud-jump-to">
                <div className="deck-hud-jump-to-container">
                  <div>{_`Level ${currentLevel}`}</div>
                  <select
                      ref="jumpTo"
                      defaultValue={currentSlideId}
                      onChange={::this.jumpTo}>
                    {TOC.map(toc => {
                      const { id: tocId } = toc;
                      return (
                        <option key={tocId} value={tocId}>
                          {tocId}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            }
          </div>
          <Progress
            className="deck-progress"
            items={TOC}
            currentSlide={currentSlide}
            type={progressType} />
        </div>
        <div
            className="deck-hud-button deck-hud-previous ppa-icon-arrow-prev"
            onClick={prevSlide}
            style={styles.hudPrevButton}>
          <span className="text-hide">{_('Previous')}</span>
        </div>
        <div
            className="deck-hud-button deck-hud-next ppa-icon-arrow-next"
            onClick={nextSlide}
            style={styles.hudNextButton}
            ref="nextArrow">
          <span className="text-hide">{_('Next')}</span>
        </div>
        { funVideoNumber && <FunVideoOverlay videoNumber={funVideoNumber} /> }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/hudTeacherRemote/hud.jsx